import { PageHeader } from '@/components/ui';

import { CartaoAuvo } from './CartaoAuvo';

/**
 * A página do Auvo — 06/09/2026, quando `Integrações` deixou de ser uma
 * pilha e cada integração ganhou a sua.
 *
 * ⚠️ O conteúdo é o MESMO cartão de antes, sem uma linha de lógica tocada.
 * **Reorganização de tela não é reorganização de dado** — o que muda é onde a
 * pessoa encontra, não o que o sistema faz.
 */
export function PaginaAuvo() {
  return (
    <section className="min-w-0 space-y-6" data-testid="pagina-auvo">
      <PageHeader className="mb-0" crumb="Configurações · Integrações" title="Auvo" subtitle="Ordens de serviço em campo. O IGM apenas LÊ o Auvo: nunca cria, altera nem conclui nada lá." />
      <CartaoAuvo />
    </section>
  );
}
